import React from 'react';
import Sym from '../components/Sym';
import SectionHead from '../components/SectionHead';

const STEPS = [
  { n: '01', icon: 'key', title: 'Conecta tu e.firma', desc: 'Subes tu FIEL vigente una sola vez. Queda cifrada y bajo tu control.' },
  { n: '02', icon: 'cloud_download', title: 'PaySlip descarga del SAT', desc: 'Con tu e.firma, baja en automático tus recibos de nómina ya timbrados y los organiza por periodo.' },
  { n: '03', icon: 'groups', title: 'Cada quien recibe el suyo', desc: 'Tus colaboradores entran a su portal y descargan su recibo en PDF o XML cuando lo necesiten.' },
];

const HowItWorks2 = () => (
  <section style={{ maxWidth: 1200, margin: '0 auto', padding: '48px clamp(20px,5vw,40px)' }}>
    <SectionHead eyebrow="Así funciona" title="Tres pasos" accent="y listo" />
    <div className="ls2-grid3" style={{ marginTop: 40 }}>
      {STEPS.map((s) => (
        <div key={s.n} style={{ position: 'relative', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 20, padding: '28px 26px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
            <span style={{ width: 48, height: 48, borderRadius: 14, background: 'rgba(47,107,255,.14)', border: '1px solid rgba(111,160,255,.28)', display: 'grid', placeItems: 'center' }}>
              <Sym name={s.icon} size={24} color="#6FA0FF" />
            </span>
            <span style={{ font: "700 2rem 'Source Serif 4'", color: 'var(--step)' }}>{s.n}</span>
          </div>
          <h3 style={{ font: "700 1.25rem 'Source Serif 4'", color: 'var(--heading)', margin: '0 0 8px' }}>{s.title}</h3>
          <p style={{ font: "400 1.02rem/1.55 'Hanken Grotesk'", color: 'var(--muted)', margin: 0 }}>{s.desc}</p>
        </div>
      ))}
    </div>
  </section>
);

export default HowItWorks2;
